import { createReducer } from '@ngrx/store';

import { emptyState } from '../@core/fetch-state.utils';

import { AppState } from './app.state.interface';
import { clientsStateReducers } from './clients/clients.reducer';
import { itemProcessesReducers } from './products/item-processes/item-processes.reducer';
import { quotesStateReducer } from './quotes/quotes.reducer';
import { userStateReducers } from './user/user.reducer';

export const initialState: AppState = {
  loggedInUser: emptyState(),
  activeUsers: emptyState(),
  activeUsersTotalCount: 0,
  archivedUsers: emptyState(),
  archivedUsersTotalCount: 0,
  fetchedUser: emptyState(),
  fetchedUserRoles: emptyState(),
  activeQuotes: emptyState(),
  activeQuotesTotalCount: 0,
  archivedQuotes: emptyState(),
  archivedQuotesTotalCount: 0,
  archivedUser: emptyState(),
  unarchivedUser: emptyState(),
  addedUser: emptyState(),
  updatedUser: emptyState(),
  changedPassword: emptyState(),
  assignees: emptyState(),
  customers: emptyState(),
  statuses: emptyState(),
  groups: emptyState(),
  categories: emptyState(),
  shippingMethods: emptyState(),
  clients: emptyState(),
  clientsTotalCount: 0,
  addedClient: emptyState(),
  loadedClient: emptyState(),
  updatedClient: emptyState(),
  duplicatedClient: emptyState(),
  countries: emptyState(),
  statesForAddress1: emptyState(),
  statesForAddress2: emptyState(),
  quotesShippingMethod: emptyState(),
  caNumbers: emptyState(),
  selectedCANumber: emptyState(),
  itemProcesses: emptyState(),
  selectedItemProcess: emptyState(),
  createdQuote: emptyState(),
  selectedQuote: emptyState(),
  itemProcessesCategories: emptyState(),
  savedNote: emptyState(),
  myOrdersList: emptyState() || null,
  myOrdersListLength: emptyState() || null,
  exportQuotesBundle: emptyState(),
  archivedQuote: emptyState(),
  unarchivedQuote: emptyState(),
  deletedQuote: emptyState(),
  createdOrder: emptyState(),
  updatedQuote: emptyState(),
  duplicatedQuote: emptyState(),
  updatedOrder: emptyState(),
};

export const appStateReducer = createReducer(
  initialState,
  ...userStateReducers,
  ...quotesStateReducer,
  ...itemProcessesReducers,
  ...clientsStateReducers,
);
